import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Warning, ArrowRight, MapPin } from "@phosphor-icons/react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function Registry() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${BASE}/api/public/counterfeit-registry`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F7F8] text-[#0A0B0D]" data-testid="registry-page">
      <nav className="border-b border-[#E5E5EA] bg-white">
        <div className="max-w-[1320px] mx-auto h-14 px-5 lg:px-8 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 bg-[#0A0B0D] text-white font-display font-bold text-[13px] flex items-center justify-center">S</div>
            <div className="font-display font-bold text-[14px] tracking-tight">SPAN</div>
            <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-[#475467] hidden sm:block">· Counterfeit Registry</div>
          </Link>
          <div className="flex items-center gap-4 text-[12px]">
            <Link to="/" className="hover:text-[#0A0B0D]/70">Home</Link>
            <Link to="/state-of-brand" className="hover:text-[#0A0B0D]/70">Annual report</Link>
            <Link to="/health-score" className="hover:text-[#0A0B0D]/70">Health Score</Link>
          </div>
        </div>
      </nav>

      <section className="border-b border-[#E5E5EA] py-12 lg:py-16 bg-[#0A0B0D] text-white">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="label-eyebrow mb-3" style={{color: "rgba(255,255,255,0.6)"}}>SPAN PUBLIC REGISTRY · ANONYMIZED</div>
          <h1 className="font-display font-bold text-[44px] sm:text-[56px] leading-[0.98] tracking-tight">
            Counterfeit clusters,<br/>flagged by the network.
          </h1>
          <p className="text-[15px] mt-5 max-w-[620px] leading-[1.6] text-white/80">
            High-severity counterfeit signals shared anonymously by SPAN-protected brands.
            No brand names — only locations, types and severity. Updated continuously.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="flex items-center justify-between mb-6">
            <div className="label-eyebrow">{items.length} active clusters</div>
            <Link to="/health-score" className="span-btn">Protect my brand <ArrowRight size={13}/></Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {items.length === 0 && (
              <div className="col-span-3 text-center text-[14px] text-[#475467] py-20">No public clusters available yet.</div>
            )}
            {items.map((s) => (
              <div key={s.shared_id} className="border border-[#E5E5EA] bg-white p-5">
                <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.18em]">
                  <Warning size={12} weight="fill" className={s.severity === "critical" ? "text-red-600" : "text-amber-600"} />
                  <span className={s.severity === "critical" ? "text-red-600" : "text-amber-600"}>{s.severity}</span>
                  <span>·</span>
                  <span>{s.signal_type}</span>
                </div>
                <div className="flex items-center gap-2 mt-3">
                  <MapPin size={14} />
                  <div className="font-display font-bold text-[14px]">{s.location}</div>
                </div>
                <div className="text-[12px] mt-2 text-[#475467] leading-[1.55]">{s.description}</div>
                <div className="font-mono text-[10px] mt-3 text-[#475467] uppercase tracking-[0.18em]">{s.category}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 border-t border-[#E5E5EA]">
        <div className="max-w-[800px] mx-auto px-5 text-center">
          <div className="label-eyebrow mb-3">JOIN THE REGISTRY</div>
          <h2 className="font-display font-bold text-[32px] tracking-tight">Your counterfeit signals could be here next week.</h2>
          <p className="text-[14px] text-[#475467] mt-3 max-w-[560px] mx-auto">
            SPAN customers on Pro and Enterprise plans automatically contribute anonymized signals.
            More signals = a denser map = faster takedowns for everyone.
          </p>
          <Link to="/pricing" className="span-btn mt-6 inline-flex">See pricing</Link>
        </div>
      </section>
    </div>
  );
}
